module.exports = __webpack_public_path__ + "static/media/ic_pet4.a712acd3.png";